import React, { useCallback, useEffect, useState } from 'react';
import Autocomplete from '../Autocomplete';
import { index as searchApi } from '@afosto/content/api/Index';

const WmsLocationSearch = ({ name, label, ...otherProps }) => {
  const [locations, setLocations] = useState([]);
  const [isFetchingLocations, setIsFetchingLocations] = useState(true);

  const searchWmsLocations = useCallback(async searchValue => {
    setIsFetchingLocations(true);
    try {
      const response = await searchApi.search({
        codes: ['wms'],
        models: ['locations'],
        namespaces: ['default'],
        q: searchValue?.length > 0 ? [searchValue] : null,
      });
      const { data = {} } = response;
      const { hits = [] } = data;
      const suggestions = hits.reduce((acc, hit) => {
        const { name: locationName, location_id: locationID } = hit.metadata || {};
        return [
          ...acc,
          {
            id: locationID,
            name: `${locationName}`,
            label: `${locationName}`,
            value: locationID,
          },
        ];
      }, []);
      setLocations(suggestions);
    } catch (error) {
      setLocations([]);
    } finally {
      setIsFetchingLocations(false);
    }
  }, []);

  useEffect(() => {
    searchWmsLocations();
  }, [searchWmsLocations]);

  /**
   * Search products based on the input value.
   * @param {Event} event
   */
  const handleSearchWmsLocation = event => {
    const { value } = event?.target ?? {};

    searchWmsLocations(value).catch(() => {
      // Do something with error.
    });
  };

  return (
    <Autocomplete
      {...otherProps}
      name={name}
      label={label}
      onInputChange={handleSearchWmsLocation}
      options={locations.map(location => ({
        ...location,
        label: location.name,
        value: location.id,
      }))}
      loading={isFetchingLocations}
      autocomplete="off"
    />
  );
};

WmsLocationSearch.propTypes = Autocomplete.propTypes;

WmsLocationSearch.defaultProps = Autocomplete.defaultProps;

export default WmsLocationSearch;
